import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import avatar2 from "../../assets/images/users/avatar-2.jpg";

const Sidebar = (props) => {
  const [username, setusername] = useState("PFTP");
  const [types, setTypes] = useState([]);
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const [UserType, setUserType] = React.useState(authUser.data.type);
  const handleTypeChange = (e) => {
    const selectedType = e.target.value;

    // Update the type in the authUser object
    authUser.data.type = parseInt(selectedType);
    authUser.data.type_id = parseInt(selectedType);

    // Save the updated authUser object back to localStorage
    localStorage.setItem("authUser", JSON.stringify(authUser));
    window.location.href = "/dashboard"
  };

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setusername(obj.data.name);
    if (obj.data.online && obj.data.onsite) {
      setTypes([
        { id: 1, name: "Online" },
        { id: 2, name: "Onsite" },
      ]);
    } else if (obj.data.online && !obj.data.onsite) {
      setTypes([{ id: 1, name: "Online" }]);
    } else if (!obj.data.online && obj.data.onsite) {
      setTypes([{ id: 2, name: "Onsite" }]);
    }
  }, [props.success]);
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="h-100">
          <div className="user-wid text-center py-4">
            <div className="user-img">
              <img
                src={avatar2}
                alt=""
                className="avatar-md mx-auto rounded-circle"
              />
            </div>

            <div className="mt-3">
              <Link to="#" className="text-dark fw-medium font-size-16">
                {username}
              </Link>
              <p className="text-body mt-1 mb-0 font-size-13">
                <select
                  className="bg-primary text-light p-1 rounded"
                  value={UserType}
                  onChange={handleTypeChange} // Handle the change
                >
                  {types.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </p>
            </div>
          </div>
          <div data-simplebar className="h-100">
            {props.type !== "condensed" ? (
              <SidebarContent />
            ) : (
              <SidebarContent />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
